webpackJsonp([273008449945333],{

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(315);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Projects = function Projects() {
	  return Glamor.createElement(
	    'div',
	    null,
	    Glamor.createElement(
	      'div',
	      { className: 'portfolio-cards-container' },
	      Glamor.createElement(
	        'div',
	        { className: 'portfolio-card Card textCenter' },
	        Glamor.createElement(
	          'h3',
	          null,
	          'Mock Linkedin'
	        ),
	        Glamor.createElement(
	          'h6',
	          null,
	          'A novice attempt at making a fully functional Linkedin type website. Users can sign up, post, like, comment. Users can also create a profile with education, experience, and skills.'
	        ),
	        Glamor.createElement(
	          'div',
	          null,
	          Glamor.createElement(
	            'h4',
	            null,
	            'Technologies Used'
	          ),
	          Glamor.createElement(
	            'div',
	            { className: 'tech-cell-container' },
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'Node.js'
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'Express.js'
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'MongoDB'
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'React.js'
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'Redux'
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'Bootstrap'
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'Docker'
	              )
	            )
	          )
	        ),
	        Glamor.createElement(
	          'div',
	          { className: 'project-container ' },
	          Glamor.createElement(
	            'a',
	            {
	              href: 'https://powerful-escarpment-50863.herokuapp.com/',
	              className: 'project-button-flex  project-button'
	            },
	            Glamor.createElement('i', { className: 'fa fa-link' }),
	            ' Live Demo'
	          ),
	          Glamor.createElement(
	            'a',
	            {
	              href: 'https://bitbucket.org/VisionsOfDrifting/mock-linkedin/src/master/',
	              className: 'project-button-flex project-button'
	            },
	            Glamor.createElement('i', { className: 'fa fa-github' }),
	            ' View Code'
	          )
	        )
	      ),
	      Glamor.createElement(
	        'div',
	        { className: 'portfolio-card Card textCenter' },
	        Glamor.createElement(
	          'h3',
	          null,
	          'IdeaStore'
	        ),
	        Glamor.createElement(
	          'h6',
	          null,
	          'Share and store your ideas! Users login with google, can post ideas, and can comment on other ideas.'
	        ),
	        Glamor.createElement(
	          'div',
	          null,
	          ' ',
	          Glamor.createElement(
	            'h4',
	            null,
	            'Technologies Used'
	          ),
	          Glamor.createElement(
	            'div',
	            { className: 'tech-cell-container' },
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'Node.js'
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'Express.js'
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'MongoDB'
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'Handlebars.js'
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'Materialize CSS'
	              )
	            )
	          )
	        ),
	        Glamor.createElement(
	          'div',
	          { className: 'project-container ' },
	          Glamor.createElement(
	            'a',
	            {
	              href: 'https://pacific-lake-95761.herokuapp.com/',
	              className: 'project-button-flex  project-button'
	            },
	            Glamor.createElement('i', { className: 'fa fa-link' }),
	            ' Live Demo'
	          ),
	          Glamor.createElement(
	            'a',
	            {
	              href: 'https://github.com/VisionsOfDrifting/IdeaStore',
	              className: 'project-button-flex project-button'
	            },
	            Glamor.createElement('i', { className: 'fa fa-github' }),
	            ' View Code'
	          )
	        )
	      ),
	      Glamor.createElement(
	        'div',
	        { className: 'portfolio-card Card textCenter' },
	        Glamor.createElement(
	          'h3',
	          null,
	          'Personal Website'
	        ),
	        Glamor.createElement(
	          'h6',
	          null,
	          'This website you\'re currently viewing. If you like my work feel free to ',
	          Glamor.createElement(
	            _gatsbyLink2.default,
	            { to: '/contact' },
	            'contact me'
	          ),
	          '.'
	        ),
	        Glamor.createElement(
	          'div',
	          null,
	          Glamor.createElement(
	            'h4',
	            null,
	            'Technologies Used'
	          ),
	          Glamor.createElement(
	            'div',
	            { className: 'tech-cell-container' },
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'Gatsby'
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'React.js'
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'Flexbox'
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'Apache'
	              )
	            )
	          )
	        ),
	        Glamor.createElement(
	          'div',
	          { className: 'project-container ' },
	          Glamor.createElement(
	            'a',
	            {
	              href: 'https://github.com/VisionsOfDrifting/PersonalWebsite/tree/master/Gatsby/nickhtpappas.com',
	              className: 'project-button-flex project-button'
	            },
	            Glamor.createElement('i', { className: 'fa fa-github' }),
	            ' View Code'
	          )
	        )
	      ),
	      Glamor.createElement(
	        'div',
	        { className: 'portfolio-card Card textCenter' },
	        Glamor.createElement(
	          'h3',
	          null,
	          'Budget Trace'
	        ),
	        Glamor.createElement(
	          'h6',
	          null,
	          'Track your budget! Users can signup and add, edit, and delete their transactions. Visualize your spending with various graphs. Documentation is on github.'
	        ),
	        Glamor.createElement(
	          'div',
	          null,
	          Glamor.createElement(
	            'h4',
	            null,
	            'Technologies Used'
	          ),
	          Glamor.createElement(
	            'div',
	            { className: 'tech-cell-container' },
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'HTML'
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'CSS'
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'JavaScript'
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'PHP'
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'MySQL'
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { className: 'tech-cell' },
	              Glamor.createElement(
	                'div',
	                { className: 'tech-box' },
	                'Apache'
	              )
	            )
	          )
	        ),
	        Glamor.createElement(
	          'div',
	          { className: 'project-container ' },
	          Glamor.createElement(
	            'a',
	            {
	              href: 'https://github.com/VisionsOfDrifting/CMPS115',
	              className: 'project-button-flex project-button'
	            },
	            Glamor.createElement('i', { className: 'fa fa-github' }),
	            ' View Code'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Projects;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _projects = __webpack_require__(209);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	__webpack_require__(314);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Portfolio = function Portfolio() {
	  return Glamor.createElement(
	    'div',
	    null,
	    Glamor.createElement(
	      'div',
	      { className: 'row' },
	      Glamor.createElement(
	        'h2',
	        null,
	        'Portfolio'
	      ),
	      Glamor.createElement(
	        'p',
	        { className: 'centeredP' },
	        'These are some of my completed projects with live demos. Feel free to try them out and look at the source code. Other projects I\'ve completed are on my github as well.'
	      )
	    ),
	    Glamor.createElement(_projects2.default, null)
	  );
	};
	
	exports.default = Portfolio;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 314:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 315:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-portfolio-portfolio-index-js-28d462e1cbd9a3be81cf.js